import { render, staticRenderFns } from "./ProjectAdd.vue?vue&type=template&id=0d8b830b"
import script from "./ProjectAdd.vue?vue&type=script&lang=js"
export * from "./ProjectAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports